import React from 'react';
import { Message } from 'semantic-ui-react';

export default function CustomErrorMessage({ value }) {
  return value && <Message error>
    <Message.Header>เกิดข้อผิดพลาด</Message.Header>
    {value}
  </Message>
}